import React from 'react';
import { cn } from '../cn';
/**
 * Design-system `<form>` wrapper — pairs with `FormField` + form controls.
 */
export const Form = ({ className, children, ...props }) => (React.createElement("form", { className: cn('w-full min-w-0', className), ...props }, children));
export default Form;
